export enum PageType {
  Contribution = "contribution",
  Trend = "trend",
  Note = "note",
  Default = "default",
  AdvancedExplorer = "advancedExplorer",
}
